import React from "react"
import styled from "styled-components"
import {media} from "../utils/media";
import {useNavigate} from "react-router-dom";

const HomeLink = styled.div`
  cursor: pointer;
  img {
    display: block;
    max-height: ${p => p.position === "header" ? "58px" : "120px"};
    ${media.phone`
      max-height: ${p => p.position === "header" ? "50px" : "90px"};
    `};
  }
`

const Logo = ({position = "header", color = "white"}) => {
  const imageUrl = `/static/logo/logo-${color}.png`
  const navigate = useNavigate();

  return (
    <HomeLink onClick={() => navigate("/")} position={position}>
      <img alt="logo" src={imageUrl} />
    </HomeLink>
  )
}

export default Logo
